class ShopByCategory extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.js-shop-by-category-swiper')
    const prevEl = this.querySelector('.shop-by-category--icon-previous')
    const nextEl = this.querySelector('.shop-by-category--icon-next')
    const scrollbarEl = this.querySelector('.js-shop-by-category-scrollbar')
    const option = {
      init: false,
      spaceBetween: 10,
      slidesPerView: 1.785,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 15,
      slidesOffsetBefore: 15,
      slidesPerGroup: 1,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
      scrollbar: {
        el: scrollbarEl,
        enabled: true,
        draggable: true,
        snapOnRelease: true,
        dragSize: 'auto',
      },
      breakpoints: {
        640: {
          slidesPerView: 2.5,
          slidesOffsetAfter: 15,
          slidesOffsetBefore: 15,
          slidesPerGroup: 2,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 3.5,
          slidesOffsetAfter: 60,
          slidesOffsetBefore: 60,
          slidesPerGroup: 3,
        },
        1400: {
          spaceBetween: 20,
          slidesPerView: 4.367,
          slidesOffsetAfter: 60,
          slidesOffsetBefore: 60,
          slidesPerGroup: 4,
        },
        1800: {
          slidesPerView: 5.5,
          slidesOffsetAfter: 60,
          slidesOffsetBefore: 60,
          spaceBetween: 20,
          slidesPerGroup: 5,
        },
      },
    }

    this.$swiper = new Swiper(swiperEl, option)
    this.$swiper.on('slideChangeTransitionEnd', (swiper) => this.onRenderSlidesIndexes(swiper))
    this.$swiper.on('afterInit', (swiper) => this.onRenderSlidesIndexes(swiper))
    this.$swiper.on('resize', (swiper) => this.onRenderSlidesIndexes(swiper))
    this.$swiper.on('fromEdge', (swiper) => this.onRenderSlidesIndexes(swiper))
    this.$swiper.on('toEdge', (swiper) => this.onRenderSlidesIndexes(swiper))
    this.$swiper.init()
  }

  disconnectedCallback() {
    if (this.$swiper && typeof this.$swiper.destroy === 'function') {
      this.$swiper.destroy(true, true)
    }
  }

  onRenderSlidesIndexes(swiper) {
    const activeIndexEl = this.querySelector('.js-shop-by-category-carousel-index')
    const totalGroupsEl = this.querySelector('.js-shop-by-category-carousel-pages')
    let currentGroupIndex = swiper.realIndex + 1
    if (swiper.params.slidesPerGroup > 1) {
      currentGroupIndex = Math.ceil(((swiper.realIndex - 1) + swiper.params.slidesPerGroup) / swiper.params.slidesPerGroup)
    }
    const totalSlides = swiper.slides.length
    const totalGroups = Math.ceil(totalSlides / swiper.params.slidesPerGroup)
    activeIndexEl.innerHTML = swiper.isEnd ? totalGroups: currentGroupIndex
    totalGroupsEl.innerHTML = totalGroups
  }
}

if (typeof customElements.get('shop-by-category') === 'undefined') {
  customElements.define('shop-by-category', ShopByCategory)
}
